module.exports = __webpack_public_path__ + "img/project_7.bd320818.png";